import actionTypes from "../action-types";
import { SchoolInfoType } from "../models/SchoolInfo";

export function receiveSchoolInfo(schoolInfo: SchoolInfoType) {
  return {
    type: actionTypes.RECEIVE_SCHOOL_INFO,
    payload: schoolInfo
  };
}
